import React from 'react'
import PropTypes from 'prop-types'

import { VideoWithLinkStyled } from '../styles/components/VideoWithLinkStyled'

import Play from './icons/play'

/**
 * A clickable video thumbnail that opens
 * an external video link in a new tab.
 * @param {ComponentProps} props
 * @param {string} props.link
 * @param {string} props.cover
 * @param {string} props.alt
 * @param {string} props.maxWidth
 * @param {string} props.className
 * @returns {FunctionComponent}
 */
const VideoWithLink = ({ link, coverImg, alt, maxWidth, className }) => (
  <VideoWithLinkStyled $maxWidth={maxWidth} className={className} href={link} target="_blank">
    <img src={coverImg} alt={alt} placeholder="none" quality="100" />
    <div className="play">
      <Play className="icon-play" />
    </div>
  </VideoWithLinkStyled>
)

VideoWithLink.propTypes = {
  link: PropTypes.string.isRequired,
  coverImg: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  maxWidth: PropTypes.string,
  className: PropTypes.string,
}

export default VideoWithLink
